export const environment = {
  production: false,
  api_endpoint: 'https://test.api.flashgreen.io/'
};
